import { useCallback, useState } from 'react';
import { UpdateInformationAboutObjectRequest } from '../../../../store/slices/dashboardSlice/types/dashboardSchema';
import { useDispatch, useSelector } from 'react-redux';
import { dashboardActions } from '../../../../store/slices/dashboardSlice/dashboardSlice';
import { editInfo } from '../../../../store/slices/dashboardSlice/action';

export const useModalUpdateInfoAboutObject = () => {
    const dispatch = useDispatch();
    //@ts-ignore
    const { modalMode, editLoader, information } = useSelector((state) => state.dashboardReducer);
    const [form, setForm] = useState<UpdateInformationAboutObjectRequest>({
        name: information.name,
        address: information.address,
        coordinates: {
            latitude: information.latitude,
            longitude: information.longitude,
        },
        contract_number: information.contract_number,
        contract_date: information.contract_date,
        description: information.description,
    });

    const [mapCenter, setMapCenter] = useState({
        lat: information.latitude,
        lng: information.longitude,
    });

    const onForm = useCallback(
        (name: string, value: string) => {
            setForm({ ...form, [name]: value });
        },
        [form]
    );

    const onCoordinates = useCallback(
        (value: { latitude: number; longitude: number }) => {
            setForm({ ...form, coordinates: value });
        },
        [form]
    );

    const onSubmit = useCallback(() => {
        dispatch(editInfo(form));
    }, [form]);
    const onCancel = useCallback(() => {
        dispatch(dashboardActions.onModalMode(null));
    }, []);

    const handleAddressSubmit = async () => {
        const geocoder = new window.google.maps.Geocoder();
        await geocoder.geocode({ address: form.address }, (results, status) => {
            if (status === 'OK' && results[0]) {
                const location = results[0].geometry.location;

                setMapCenter((prevState) => ({
                    ...prevState,
                    lat: location.lat(),
                    lng: location.lng(),
                }));
                setForm((prevState) => ({
                    ...prevState,
                    coordinates: {
                        latitude: location.lat(),
                        longitude: location.lng(),
                    },
                }));
            }
        });
    };

    return {
        form,
        onForm,
        onCoordinates,
        onSubmit,
        onCancel,
        modalMode,
        editLoader,
        handleAddressSubmit,
        mapCenter,
    };
};
